import React from 'react';
import moment from "moment/moment";
import {useTranslation} from "react-i18next";

const useTimeConvert = (time: string) => {
    const { t } = useTranslation();

    const convertTime = (date: any) => {
        let lang: any = localStorage.getItem("lang");
        if (lang === "th") {
            moment.locale(lang);
            let dt = moment(date).format(`DD MMMM YYYY HH:mm`);
            let t_date = dt.split(" ")[0];
            let t_month = t(dt.split(" ")[1]);
            let t_year = dt.split(" ")[2];
            let t_time = dt.split(" ")[3];
            return `${t_date} ${t_month} ${parseInt(t_year) + 543}, ${t_time} น.`;
        } else {
            moment.locale(lang);
            return moment(date).format("DD MMMM YYYY hh:mm A");
        }
    };

    return convertTime(time);
}

export default useTimeConvert